import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import EditarImagem from "../EditarImagem";
import InfoInput from "./InfoInput";
import StatusToggle from "./StatusToggle"; // Import StatusToggle

const VendedorCarteiraHeader = ({
  carteira,
  imagens,
  handleImageUpload,
  setImagem,
  save,
  handleInputChange,
  toggleSave,
  handleSave,
  onTagChange,
}) => {
  const isSaveDisabled = save !== carteira.id;
  const url = `https://www.uniscestudantil.org.br/carteiras/`;
  return (
    <div
      className="w-full rounded-2xl flex m-2.5 p-1.5 justify-between items-start"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="max-w-36 max-h-48 rounded-2xl">
        <EditarImagem
          img={imagens[carteira.id]}
          handleImageUpload={handleImageUpload}
          setImagem={setImagem}
          imagemInicial={carteira.foto}
          carteiraId={carteira.id}
          save={save}
          isRecepcionada={carteira.status === "Recepcionada"}
        />
      </div>
      <div className="flex flex-col mx-2 flex-grow">
        <InfoInput
          placeholder="NOME"
          name="name"
          value={carteira.name.toUpperCase()}
          onChange={handleInputChange}
          id={carteira.id}
          disabled={isSaveDisabled}
        />
        <InfoInput
          placeholder="INSTIUIÇÃO DE ENSINO"
          name="instituicaoEnsino"
          value={carteira.instituicaoEnsino.toUpperCase()}
          onChange={handleInputChange}
          id={carteira.id}
          disabled={isSaveDisabled}
        />
        <InfoInput
          placeholder="CURSO"
          name="curso"
          value={carteira.curso.toUpperCase()}
          onChange={handleInputChange}
          id={carteira.id}
          disabled={isSaveDisabled}
        />
        <div className="flex w-full text-sm font-bold">
          <InfoInput
            label="CPF:"
            name="cpf"
            value={carteira.cpf}
            onChange={handleInputChange}
            id={carteira.id}
            disabled={isSaveDisabled}
          />
        </div>
        <div className="flex w-full text-sm font-bold">
          <InfoInput
            label="RG:"
            name="rg"
            value={carteira.rg}
            onChange={handleInputChange}
            id={carteira.id}
            disabled={isSaveDisabled}
          />
          <InfoInput
            label="DN:"
            name="dataNascimento"
            value={carteira.dataNascimento}
            onChange={handleInputChange}
            id={carteira.id}
            disabled={isSaveDisabled}
          />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center w-1/5 ml-2">
        <QRCodeCanvas
          className="qrCode"
          value={url + carteira.id}
          size={100}
          marginSize={1}
        />
        <span className="font-bold my-2.5"> {carteira.codigoUso}</span>
      </div>
      <div className="flex h-full flex-col items-center justify-around ml-2">
        <StatusToggle
          id={carteira.id}
          isActive={carteira.tag === "APROVADA" ? true : false}
          onToggle={() =>
            onTagChange(
              carteira.id,
              carteira.tag === "APROVADA" ? "PENDENTE" : "APROVADA"
            )
          }
          activeText="APROVADA"
          inactiveText="PENDENTE"
          activeBgColor="bg-green-500"
          inactiveBgColor="bg-yellow-500"
          activeTextColor="text-white"
          inactiveTextColor="text-white"
        />
        <button
          className="bg-green-600 transition-colors font-league-gothic text-lg border-none text-white w-full rounded-lg mt-2"
          onClick={(e) => {
            e.stopPropagation();
            toggleSave(carteira.id);
          }}
        >
          {save === carteira.id ? (
            <button
              className="bg-green-600 transition-colors font-league-gothic text-base border-none text-white"
              onClick={(e) => {
                handleSave(e, carteira.id);
              }}
            >
              {" "}
              SALVAR{" "}
            </button>
          ) : (
            "EDITAR"
          )}
        </button>
        <a
          className="text-center bg-indigo-800 no-underline font-league-gothic text-lg border-none text-white w-full rounded-lg"
          href={`/carteiras/${carteira.id}`}
          target="_blank"
          rel="noreferrer"
        >
          VISUALIZAR
        </a>
      </div>
    </div>
  );
};

export default VendedorCarteiraHeader;
